import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AffectedFlow } from '../../../../../../../redux/slices/customer_node_definitionsSlice';

interface Props {
  removedNames: string[];
  affectedFlows: AffectedFlow[];
  onConfirm: () => void;
  onCancel: () => void;
}

const RemoveParameterModal = ({ removedNames, affectedFlows, onConfirm, onCancel }: Props) => {
  return (
    <Modal show onHide={onCancel} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Parameter removed from flows</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          The following parameter{removedNames.length > 1 ? 's are' : ' is'} used in <strong>{affectedFlows.length}</strong> flow
          {affectedFlows.length > 1 ? 's' : ''} and will be removed from their mappings:
        </p>
        <ul className="mb-3">
          {removedNames.map((n) => (
            <li key={n}>
              <code>{n}</code>
            </li>
          ))}
        </ul>
        <p className="mb-1">
          <strong>Affected flows:</strong>
        </p>
        <ul>
          {affectedFlows.map((f) => (
            <li key={`${f.parent_definition_id}-${f.flow_node_id}`}>
              <strong>{f.zone_name}</strong> / {f.flow_name}
              {f.flow_node_label ? ` — node "${f.flow_node_label}"` : ''}
            </li>
          ))}
        </ul>
        <p className="mt-3 text-muted">Saving will remove these parameter mappings from the listed flows. This cannot be undone automatically.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Save and update flows
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveParameterModal;
